import { fetchApi } from '../utils/api';
import type { ApiResponse } from '../types';

export class ApiClient {
  private baseUrl: string;

  constructor(baseUrl?: string) {
    this.baseUrl = baseUrl ?? (typeof window === 'undefined' 
      ? process.env.NEXT_PUBLIC_API_URL ?? ''
      : window.location.origin);
  }

  async get<T>(endpoint: string, options: RequestInit = {}): Promise<ApiResponse<T>> {
    return fetchApi<T>(endpoint, {
      baseUrl: this.baseUrl,
      method: 'GET',
      ...options,
    });
  }

  async post<T>(endpoint: string, data: unknown, options: RequestInit = {}): Promise<ApiResponse<T>> {
    return fetchApi<T>(endpoint, {
      baseUrl: this.baseUrl,
      method: 'POST',
      body: JSON.stringify(data),
      ...options,
    });
  }

  async put<T>(endpoint: string, data: unknown, options: RequestInit = {}): Promise<ApiResponse<T>> {
    return fetchApi<T>(endpoint, {
      baseUrl: this.baseUrl,
      method: 'PUT',
      body: JSON.stringify(data),
      ...options,
    });
  }

  async patch<T>(endpoint: string, data: unknown, options: RequestInit = {}): Promise<ApiResponse<T>> {
    return fetchApi<T>(endpoint, {
      baseUrl: this.baseUrl,
      method: 'PATCH',
      body: JSON.stringify(data),
      ...options,
    });
  }

  async delete<T>(endpoint: string, options: RequestInit = {}): Promise<ApiResponse<T>> {
    return fetchApi<T>(endpoint, {
      baseUrl: this.baseUrl,
      method: 'DELETE',
      ...options,
    });
  }
} 